import type { OklchColor } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/controls/modals/projectCover/types";

const FULL_TURN_DEGREES = 360;

export const formatOklchColor = (
  [lightness, chroma, hue]: OklchColor,
  hueDriftDegrees: number
): string => {
  const driftedHue =
    (hue + hueDriftDegrees + FULL_TURN_DEGREES) % FULL_TURN_DEGREES;
  // Rounded so the server and client renders print the same attribute: an unrounded float can differ in its last digit between engines and trip a hydration mismatch.
  return `oklch(${lightness} ${chroma} ${driftedHue.toFixed(2)})`;
};
